import { TextButton } from 'component/button';
import { InformationalModal } from 'component/modal/informational-modal';
import type { VideoVoting } from 'open-modules/zdf/component/videovoting/index';
import { View } from 'react-native';
import { t } from 'util/stdtypes';

type VotingSelectionModalProps = {
    votings: VideoVoting[];
    onClose: () => void;
    onSelect: (voting: VideoVoting) => void;
};

export function VotingSelectionModal({ votings, onClose, onSelect }: VotingSelectionModalProps) {
    return (
        <InformationalModal
            content={
                <View style={{ gap: 8 }}>
                    {votings.map((voting) => (
                        <TextButton
                            key={voting.votingKey}
                            onPress={() => {
                                onSelect(voting);
                            }}
                            text={voting.name}
                        />
                    ))}
                </View>
            }
            headingLabel={t('videovoting.select_existing_voting', 'Select an existing Video Voting')}
            onClose={onClose}
        />
    );
}
